// Brand icon set + colour data — faithfully recreated from the uploaded SVGs.
// Palette: ink #12263A, accent #C79A3B, slate #6B7280.
import React from "react";

const INK = "#12263A";
const ACCENT = "#C79A3B";

function Frame({ viewBox, children }) {
  return (
    <svg viewBox={viewBox} width="100%" height="100%" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      {children}
    </svg>
  );
}

export const PropDetached = () => (
  <Frame viewBox="74 146 114 92">
    <g fill="none" stroke={INK} strokeWidth="4" strokeLinejoin="round" strokeLinecap="round">
      <line x1="78" y1="235" x2="182" y2="235" />
      <polygon points="88,188 130,150 172,188" />
      <rect x="95" y="188" width="70" height="47" />
    </g>
    <rect x="122" y="212" width="16" height="23" fill="none" stroke={INK} strokeWidth="3" />
    <rect x="101" y="196" width="15" height="13" fill="none" stroke={INK} strokeWidth="3" />
    <rect x="144" y="196" width="15" height="13" fill="none" stroke={INK} strokeWidth="3" />
  </Frame>
);

export const PropSemi = () => (
  <Frame viewBox="276 158 140 82">
    <g fill="none" stroke={INK} strokeWidth="4" strokeLinejoin="round" strokeLinecap="round">
      <line x1="280" y1="235" x2="410" y2="235" />
      <polygon points="286,190 317,164 348,190" />
      <polygon points="342,190 373,164 404,190" />
      <rect x="290" y="190" width="55" height="45" />
      <rect x="345" y="190" width="55" height="45" />
    </g>
    <rect x="310" y="214" width="14" height="21" fill="none" stroke={INK} strokeWidth="3" />
    <rect x="366" y="214" width="14" height="21" fill="none" stroke={INK} strokeWidth="3" />
  </Frame>
);

export const PropTerraced = () => (
  <Frame viewBox="474 166 152 74">
    <g fill="none" stroke={INK} strokeWidth="3.5" strokeLinejoin="round" strokeLinecap="round">
      <line x1="478" y1="235" x2="622" y2="235" />
      <polygon points="483,192 506,172 529,192" />
      <polygon points="526,192 549,172 572,192" />
      <polygon points="569,192 592,172 615,192" />
      <rect x="486" y="192" width="43" height="43" />
      <rect x="529" y="192" width="43" height="43" />
      <rect x="572" y="192" width="43" height="43" />
    </g>
    <g fill="none" stroke={INK} strokeWidth="2.5">
      <rect x="501" y="214" width="12" height="21" />
      <rect x="544" y="214" width="12" height="21" />
      <rect x="587" y="214" width="12" height="21" />
    </g>
  </Frame>
);

export const RoofFelt = () => (
  <Frame viewBox="80 450 100 64">
    <rect x="92" y="478" width="76" height="32" fill="none" stroke={INK} strokeWidth="4" />
    <rect x="85" y="455" width="90" height="23" rx="2" fill="#2E3742" stroke={INK} strokeWidth="4" />
    <g stroke="#C7CCD2" strokeWidth="2">
      <line x1="90" y1="461" x2="170" y2="461" />
      <line x1="90" y1="466" x2="170" y2="466" />
      <line x1="90" y1="471" x2="170" y2="471" />
    </g>
  </Frame>
);

export const RoofGrp = () => (
  <Frame viewBox="290 450 100 64">
    <rect x="302" y="478" width="76" height="32" fill="none" stroke={INK} strokeWidth="4" />
    <rect x="295" y="455" width="90" height="23" rx="2" fill={ACCENT} stroke={INK} strokeWidth="4" />
    <line x1="305" y1="467" x2="345" y2="460" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" opacity="0.8" />
  </Frame>
);

export const RoofTiled = () => (
  <Frame viewBox="502 430 96 84">
    <rect x="515" y="476" width="70" height="34" fill="none" stroke={INK} strokeWidth="4" />
    <polygon points="506,476 550,440 594,476" fill="#2A3340" stroke={INK} strokeWidth="4" strokeLinejoin="round" />
    <g stroke="#C7CCD2" strokeWidth="2">
      <line x1="522" y1="463" x2="578" y2="463" />
      <line x1="514" y1="470" x2="586" y2="470" />
    </g>
    <rect x="545" y="435" width="10" height="10" rx="1.5" transform="rotate(45 550 440)" fill={ACCENT} />
  </Frame>
);

export const DoorFrench = () => (
  <Frame viewBox="82 706 98 88">
    <g fill="none" stroke={INK} strokeWidth="4" strokeLinejoin="round" strokeLinecap="round">
      <line x1="86" y1="790" x2="176" y2="790" />
      <rect x="98" y="712" width="64" height="78" />
      <line x1="130" y1="712" x2="130" y2="790" />
      <line x1="114" y1="722" x2="114" y2="780" />
      <line x1="146" y1="722" x2="146" y2="780" />
    </g>
    <g stroke={ACCENT} strokeWidth="4" strokeLinecap="round">
      <line x1="125" y1="745" x2="125" y2="757" />
      <line x1="135" y1="745" x2="135" y2="757" />
    </g>
  </Frame>
);

export const DoorBifold = () => (
  <Frame viewBox="284 706 112 88">
    <g fill="none" stroke={INK} strokeWidth="4" strokeLinejoin="round" strokeLinecap="round">
      <line x1="288" y1="790" x2="392" y2="790" />
      <rect x="298" y="712" width="74" height="78" />
      <line x1="316" y1="712" x2="316" y2="790" />
      <line x1="335" y1="712" x2="335" y2="790" />
      <line x1="354" y1="712" x2="354" y2="790" />
    </g>
    <polygon points="372,712 392,720 392,782 372,790" fill={ACCENT} fillOpacity="0.18" stroke={ACCENT} strokeWidth="3" strokeLinejoin="round" />
  </Frame>
);

export const WallBrick = () => (
  <Frame viewBox="506 706 88 88">
    <defs>
      <clipPath id="de_brk_clip"><rect x="510" y="710" width="80" height="80" rx="8" /></clipPath>
    </defs>
    <g clipPath="url(#de_brk_clip)">
      <rect x="510" y="710" width="80" height="80" fill="#F2EEE8" />
      <g fill="none" stroke={INK} strokeWidth="2">
        <rect x="506" y="712" width="26" height="14" /><rect x="534" y="712" width="26" height="14" /><rect x="562" y="712" width="26" height="14" />
        <rect x="493" y="728" width="26" height="14" /><rect x="521" y="728" width="26" height="14" /><rect x="549" y="728" width="26" height="14" /><rect x="577" y="728" width="26" height="14" />
        <rect x="506" y="744" width="26" height="14" /><rect x="562" y="744" width="26" height="14" />
        <rect x="493" y="760" width="26" height="14" /><rect x="521" y="760" width="26" height="14" /><rect x="549" y="760" width="26" height="14" /><rect x="577" y="760" width="26" height="14" />
        <rect x="506" y="776" width="26" height="14" /><rect x="534" y="776" width="26" height="14" /><rect x="562" y="776" width="26" height="14" />
      </g>
      <rect x="534" y="744" width="26" height="14" fill={ACCENT} />
    </g>
    <rect x="510" y="710" width="80" height="80" rx="8" fill="none" stroke={INK} strokeWidth="3" />
  </Frame>
);

export const WallRender = () => (
  <Frame viewBox="716 706 88 88">
    <rect x="720" y="710" width="80" height="80" rx="8" fill="#EFEAE3" stroke={INK} strokeWidth="3" />
    <g fill="#9AA1AA">
      <circle cx="740" cy="732" r="1.6" /><circle cx="760" cy="745" r="1.6" /><circle cx="775" cy="728" r="1.6" />
      <circle cx="748" cy="762" r="1.6" /><circle cx="770" cy="770" r="1.6" /><circle cx="735" cy="775" r="1.6" /><circle cx="785" cy="755" r="1.6" />
    </g>
    <path d="M728,775 Q760,760 792,772" fill="none" stroke={ACCENT} strokeWidth="3" strokeLinecap="round" />
  </Frame>
);

// ---- Knock-through connection icons (line style) ----
export const KnockDoor = ({ active }) => {
  const c = active ? ACCENT : INK;
  return (
    <svg viewBox="0 0 48 48" width="100%" height="100%" fill="none" stroke={c} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="5" y1="42" x2="43" y2="42" />
      <rect x="9" y="7" width="30" height="35" />
      <rect x="20" y="18" width="8" height="24" />
    </svg>
  );
};

export const KnockPartial = ({ active }) => {
  const c = active ? ACCENT : INK;
  return (
    <svg viewBox="0 0 48 48" width="100%" height="100%" fill="none" stroke={c} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="5" y1="42" x2="43" y2="42" />
      <line x1="10" y1="9" x2="10" y2="42" />
      <line x1="38" y1="9" x2="38" y2="42" />
      <line x1="10" y1="9" x2="20" y2="9" />
      <line x1="28" y1="9" x2="38" y2="9" />
      <line x1="10" y1="18" x2="38" y2="18" strokeDasharray="4 3" />
    </svg>
  );
};

export const KnockFull = ({ active }) => {
  const c = active ? ACCENT : INK;
  return (
    <svg viewBox="0 0 48 48" width="100%" height="100%" fill="none" stroke={c} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="5" y1="42" x2="43" y2="42" />
      <line x1="9" y1="16" x2="9" y2="42" />
      <line x1="39" y1="16" x2="39" y2="42" />
      <rect x="5" y="9" width="38" height="7" rx="1.5" fill={c} stroke="none" />
    </svg>
  );
};

// ---- Colour data (from the uploaded charts) ----
export const BRICK_COLOURS = [
  { key: "red_multi", label: "Red multi", brick: "#9E3B2E", mortar: "#C9A98F" },
  { key: "red_smooth", label: "Red smooth", brick: "#A83D2C", mortar: "#C9A98F" },
  { key: "buff", label: "Buff / yellow", brick: "#D9C284", mortar: "#CFC1A0" },
  { key: "london_stock", label: "London stock", brick: "#B79B72", mortar: "#C2AE92" },
  { key: "grey_slate", label: "Grey / slate", brick: "#6E6E6E", mortar: "#B7B5B0" },
];

export const WINDOW_COLOURS = [
  { key: "anthracite", label: "Anthracite", sub: "RAL 7016", hex: "#3A3D40" },
  { key: "jet_black", label: "Jet black", sub: "RAL 9005", hex: "#1C1C1C" },
  { key: "white", label: "White", sub: "RAL 9016", hex: "#FFFFFF" },
  { key: "cream", label: "Cream", sub: "RAL 9001", hex: "#EFE7D6" },
  { key: "chartwell_green", label: "Chartwell green", sub: "soft sage", hex: "#3F4B3F" },
  { key: "agate_grey", label: "Agate grey", sub: "RAL 7038", hex: "#6E7479" },
  { key: "slate_blue", label: "Slate blue", sub: "RAL 7015", hex: "#23303B" },
  { key: "irish_oak", label: "Irish oak", sub: "woodgrain", hex: "#7A6A55" },
  { key: "rosewood", label: "Rosewood", sub: "woodgrain", hex: "#5A3A24" },
  { key: "wine_red", label: "Wine red", sub: "RAL 3005", hex: "#8E1F1F" },
];

export const brickByKey = (k) => BRICK_COLOURS.find((b) => b.key === k) || BRICK_COLOURS[0];
export const windowByKey = (k) => WINDOW_COLOURS.find((w) => w.key === k) || WINDOW_COLOURS[0];
